import React from "react";
import { injectIntl } from "react-intl";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { compose } from "recompose";
import {} from "../../../utilities/constants";

const LanguageNavigator = ({ language }) => {
  return (
    <Grid
      container
      justify="space-between"
      alignItems="center"
      style={{ minHeight: "100px" }}
    >
      <Grid item>
        <Grid container direction="column">
          <Grid item>
            {language && (
              <Typography
                variant="subtitle1"
                style={{
                  textAlign: "left",
                  wordBreak: "break-word",
                  fontSize: "13px",
                  lineHeight: "16px",
                  letterSpacing: "2.08px",
                  fontWeight: "400",
                  color: "inherit",
                }}
              >
                {language.label}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const enhance = compose(injectIntl);

export default enhance(LanguageNavigator);
